import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { reservationEmailModification, getSingleReservationEmail } from "./ReservationEmailAction";
import { useForm } from "react-hook-form";
import { useParams , useNavigate,Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { getAllReservationEmail } from "./ReservationEmailAction";
import { FaArrowLeft } from 'react-icons/fa';


const initialState = {
  id: "",
  email: "",
  status: "",

}



const ModifyReservationEmail = () => {
  let navigate = useNavigate();
    const {id}=useParams();

    const { stismloading, stmstatus, stmmessage  } = useSelector((state) => state.reservationEmailsList);

    const dispatch = useDispatch();
    
    const [emails, setReservationemails] = useState({
      id:"",
      email:"",
      status:""
    });
    
    useEffect(() => {
      dispatch(getAllReservationEmail());
     
  }, [dispatch,stmmessage]);

    const [status, setStatus] = useState(0);
    const [modify, setModify] = useState(0);

    const reservationEmailData = useSelector((state) => state.reservationEmailsList);



    const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      loadReservationEmail(id);
      return;
    }

  });
   useEffect(() => { 
    console.log('useEffect');
    loadReservationEmail(id);
    setReservationemails({id:id,email:'',status:''});
   
     }, []);

     
     
 
    const { register, handleSubmit, formState: { errors } } = useForm();

   

    function loadReservationEmail(id){
    
      dispatch(getSingleReservationEmail(id));
      setReservationemails({id:id,email:uData.reservation_email,status:uData.status});
   }

  
   const uData = JSON.parse(JSON.stringify(reservationEmailData.stSDetails));
   console.log(uData.email);

  const handleOnChange = e => {
    const name = e.target.name;
    const value = e.target.value;

    setReservationemails({ ...emails, [name]: value });
   
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
  
    const { id, email, status
    } = emails;
    if (email === "" && status === "") {
      Swal.fire('No changes made!', '', 'info');
      navigate('/reservationEmailList');
      return;
    }
    const reservationemailUpdation1 = {
      id,
      email,
      status
    };
   
    dispatch(reservationEmailModification(reservationemailUpdation1));
    setModify(1);
    navigate('/reservationEmailList');
    Swal.fire({
      title: 'Success!',
      text: 'Reservation Email Updated Successfully',
      icon: 'success',
      confirmButtonText: 'Okay'
    })

   
   
  
  };



  return (
    <>
      {/* <Container className="my-4 mx-4 container-xl ">

      <Card  style={{marginLeft:'100px',marginTop:'-60px'}}>
          <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2">Modify Reservation Email</h4></Card.Header>
          <Card.Body>
          <Row>
              <Col>
      
              <Link to="/reservationEmailList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
              <br />
              </Col>
            </Row> */}
             <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-50px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Modify Reservation Email</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/reservationEmailList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={handleOnSubmit}>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridUsername">
                  <Form.Label>Reservation Email</Form.Label>
                  <Form.Control type="hidden" name="id" autoComplete='off' value={id} />
                 <Form.Control type="text"  name="email" value={emails.email ? emails.reservation_email : uData.reservation_email} autoComplete='off' placeholder="Enter Reservation Email" {...register("email", { required: true, minLength: 3 })} onChange={handleOnChange}/>
                </Form.Group>
               
              
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" value={emails.status ? emails.status : uData.status}  {...register("status")} onChange={handleOnChange}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                  {errors.status && <p className='text-danger'>Status required</p>}
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle'>
              <FontAwesomeIcon icon={faRightToBracket} /> Update
              </Button>
              </div>
            
            </Form>
            </div>
            </div>
            </div>
    </>
  );
}

export default ModifyReservationEmail;